<template>
  <div :class="$style.container">
    <Modal :statusCode="codeError"
    :type="'login'"
    @disable="(vl) => modalShow = vl"
    :showModal="modalShow"/>
    <Loading v-if="isLoading"/>
    <div :class="$style.coloredBack">
      <div :class="$style.header">
        <div :class="$style.contentLeft">
          <div :class="$style.logoCuprum">
            <img
              loading="lazy"
              src="@/assets/images/CuprumWhite.svg"
              width="193"
              alt="Logo de Cuprum AFP, imagen."
              name="Logo"
              role="Img"
              aria-label="Logo de Cuprum AFP, imagen. "
              tabindex="1"
            />
          </div>
          <div :class="$style.title">
            <PdsTexting
            name="Titulo"
            role="Textbox"
            aria-label="Acceso beneficiarios de pensión Cuprum, encabezado."
            tabindex="2"
            :class="$style.titleText"
            format="h1">
              Acceso beneficiarios de pensi&oacute;n Cuprum
            </PdsTexting>
          </div>
          <hr :class="$style.hLine">
          <PdsTexting format="h3"
            tabindex="3"
            :class="$style.subtitle"
            aria-label="Este portal te ayudará a estar
            informado y a administrar tus fondos, encabezado">
            Este portal te ayudará a estar informado y administrar tus fondos.
          </PdsTexting>
        </div>
        <div :class="$style.login"
          tabindex="4"
          aria-label="Formulario de acceso a sitio beneficiarios.
          Posee dos campos. Un botón y dos enlaces">
          <Login :loading="isLoading" @showModal="(vl) => this.modalShow = vl"
          @error="(er) => this.codeError = er"
          @isLoading="(ld) => isLoading = ld"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PdsTexting from '@vue-pds/texting';
import Login from '@/components/Login';
import Loading from '@/components/Loading';
import Modal from '@/components/Modal';

export default {
  name: 'LandingLogin',
  components: {
    PdsTexting,
    Login,
    Loading,
    Modal,
  },
  data() {
    return {
      isLoading: false,
      modalShow: false,
      codeError: 0,
    };
  },
};
</script>

<style lang="scss" module>

:root {
  --icon-alert-color: #b30000;
  --icon-info-color: #0091da;
}

.container {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 480px;
  margin: 0 auto;

  & .coloredBack {
    background-color: #035fa4;
    border-bottom: #0076cf solid 3px;

    & .header {
      display: flex;
      justify-content: space-between;
      max-width: 1440px;
      height: 674px;
      padding: 72px 24px 0;
      margin: 0 auto;

      & .login {
        margin-top: 16px;
      }

      & .contentLeft {
        padding-right: 112px;
        color: white;

        & .title {
          padding: 24px 0;

          & .titleText {
            font-size: 50px !important;
            line-height: 66px;
          }
        }

        & .subtitle {
          margin-top: 16px;
          font-size: 26px !important;
          line-height: 34px;
        }

        & .hLine {
          width: 57px;
          margin: 0;
          border: 0.5px solid #ffc82e;
        }
      }
    }
  }

  & .footer {
    max-width: 1440px;
    margin: 56px auto 328px;
    text-align: center;

    & .contentLeftFooter {
      padding: 0 50px;
      margin-top: 52px;
      text-align: center;

      & .titleFooter {
        padding: 25px 0;
        line-height: 46px;

        & .footerText {
          font-size: 30px !important;
        }
      }

      & .subtitleFooter {
        line-height: 29px !important;

        & .subText {
          font-size: 22px !important;
        }
      }
    }
  }
}

@media (max-width: 767px) {
  .container {
    & .coloredBack {
      & .header {
        flex-direction: column;
        height: 1000px;
        padding-right: 0;

        & .login {
          margin: 30px auto 0;
        }

        & .contentLeft {
          padding-bottom: 0;
          padding-left: 25px;

          & .title {
            & .titleText {
              font-size: 50px !important;
            }
          }

          & .subtitle {
            display: none;
          }
        }
      }

      & .footer {
        margin: 35px auto 200px;
        text-align: center;

        & .contentLeftFooter {
          padding: 0 20px;
          margin-top: 0;
          text-align: center;

          & .titleFooter {
            padding: 25px 0;
            line-height: 46px;

            .footerText {
              font-size: 26px !important;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 575px) {
  .container {
    & .header {
      flex-direction: column;

      & .contentLeft {
        & .title {
          font-size: 40px;
          line-height: 40px;
        }

        & .subtitle {
          font-size: 20px;
        }
      }
    }

    & .footer {
      & .contentLeftFooter {
        padding: 0 10px;

        & .titleFooter {
          font-size: 30px;
          line-height: 40px;
        }
      }
    }
  }
}

@media (max-width: 360px) {
  .container {
    & .coloredBack {
      & .header {
        & .login {
          margin: 30px 10px 0;
        }
      }
    }
  }
}
</style>
